import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { faqs } from "../../data/faqs";
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-mist px-4 py-16 sm:px-6 sm:py-20" data-id="element-194" data-mp="2z3qrdtv6bcnp">
      <div className="mx-auto max-w-3xl" data-id="element-195" data-mp="3msjh38l7co9v">
        <SectionHeading kicker="Frequently asked questions" title="Everything you need to know before purchasing" data-id="element-196" data-mp="3mtl3uabkyz7f" />

        <ul className="mt-10 space-y-3" data-id="element-197" data-mp="3rtqoh6jfnlg0">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.question} className="overflow-hidden rounded-2xl bg-white" data-id="element-198" data-mp="3i1b98gzitayt" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-start justify-between gap-4 p-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-brand" data-id="element-199" data-mp="9lrippq8i6ng">
                  <span className="text-lg font-bold leading-snug text-ink" data-id="element-200" data-mp="2agrzgbl0fz99">
                    {i + 1}. {f.question}
                  </span>
                  <PlusIcon className={`mt-0.5 h-6 w-6 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-201" data-mp="25nqf3o21b7ia" />
                </button>
                <AnimatePresence initial={false} data-id="element-202" data-mp="2tdb9r47jvt7e">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-203" data-mp="2ogu9jbn2tody">
                      <div className="space-y-2 px-5 pb-5 leading-relaxed text-ink-muted" data-id="element-204" data-mp="1nrqzuimg8oog">
                        {f.answer.map(p => <p key={p} data-id="element-205" data-mp="1sqc0gj5m5adf">{p}</p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <CTAButton className="mt-10" label="All clear — I’m ready to start" note="Just $27 USD · Instant digital access" data-id="element-206" data-mp="22ngq4syo3nyz" />
      </div>
    </section>;
}